import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'validationError',
    'form',
    'emailAndPassword',
    'twoFactorCode',
    'submit',
  ];

  submit() {
    this.disableSubmit();

    const payload = $(this.formTarget).serializeArray().filter((item) => item.value);

    const twoFactorCode = payload.find((item) => item.name === 'user[otp_attempt]');
    const isSubmittingWithTwoFactorCode = twoFactorCode && twoFactorCode.value;

    $.ajax({
      method: this.formTarget.method,
      url: this.formTarget.action,
      data: payload,
      success: (response) => {
        if (isSubmittingWithTwoFactorCode && response.requires_two_factor_authentication) {
          this.showValidationError('Esse código está inválido. Tente novamente com outro código.');
          this.enableSubmit();

          return;
        }

        if (response.requires_two_factor_authentication) {
          this.emailAndPasswordTargets.forEach((element) => $(element).hide());
          this.twoFactorCodeTargets.forEach((element) => $(element).show());
          this.enableSubmit();

          return;
        }

        window.location.href = response.redirect_to || this.formTarget.getAttribute('data-redirect-to');
      },
      error: () => {
        this.showValidationError('Email ou senha incorretos.');
        this.enableSubmit();
      },
    });
  }

  showValidationError(message) {
    const $alert = $(this.validationErrorTarget);

    $alert.html(message);
    $alert.removeClass('hidden fadeOutUp');
    $alert.addClass('fadeInDown');

    setTimeout(() => {
      $alert.removeClass('fadeInDown');
      $alert.addClass('fadeOutUp');
    }, 3000);
  }

  enableSubmit() {
    const $submit = $(this.submitTarget);

    $submit.val('Entrar');
    $submit.prop('disabled', false);
  }

  disableSubmit() {
    const $submit = $(this.submitTarget);

    $submit.val('Entrando...');
    $submit.prop('disabled', true);
  }
}
